class EventBus {
	list = {}

	constructor(options) {
		if (EventBus.instance) {
			return EventBus.instance
		}
		EventBus.instance = this

		const defaultOptions = {
			debug: false,
		}
		this.options = Object.assign(defaultOptions, options)
	}

	emit(event, eventObject = {}) {
		eventObject._name = event
		if (this.list[event]) {
			if (this.options.debug) {
				console.info(
					`${this.list[event].length} handler${
						this.list[event].length > 1 ? 's' : ''
					} called on event '${event}'`
				)
			}

			this.list[event].forEach((handlerObject) => {
				if (!handlerObject.handler) {
					console.warn(`Handler on ${event} is undefined`)
					return
				}
				handlerObject.handler(eventObject)

				if (handlerObject.once) {
					this.off(event, handlerObject.handler)
				}
			})
		} else {
			if (this.options.debug) {
				console.info(`0 handlers called on event '${event}'`)
			}
		}
	}

	on(event, handler, once = false) {
		if (this.list[event]) {
			this.list[event].push({ once: once, handler: handler })
		} else {
			this.list[event] = []
			this.list[event].push({ once: once, handler: handler })
		}
	}

	once(event, handler) {
		this.on(event, handler, true)
	}

	off(event, handler) {
		if (event != null) {
			if (handler != null) {
				if (
					this.list[event] &&
					this.list[event].filter(
						(eventObject) => eventObject.handler === handler
					).length
				) {
					let toRemove = this.list[event].filter(
						(eventObject) => eventObject.handler === handler
					)[0]
					let index = this.list[event].indexOf(toRemove)
					if (index > -1) {
						this.list[event].splice(index, 1)
					}
				} else {
					console.warn(
						`Event ${event} cannot be unsubscribed - does not exist.`
					)
				}
			} else {
				this.list[event] = []
			}
		} else {
			this.list = {}
		}
	}
}

const eventBusInstance = new EventBus()
export { eventBusInstance as EventBus }

// ------------------------------------------------------------------------- //
/**
 *
 */
class SmplComponents {
	static instance
	//
	instances = []
	components = []
	// width;
	constructor() {
		if (SmplComponents.instance) {
			return SmplComponents.instance
		}
		SmplComponents.instance = this
	}

	setup(options) {
		this.options = options
		this.path = options.path
		this.componentsDef = options.components
	}

	createInstance(element, name, component) {
		component.prototype._name = name
		const instance = new component(element, { debug: this.options.debug })
		instance.prepare()
		return instance
	}

	loadComponent(element, componentDef) {
		// const lala = 'components/';
		let promise = import(`../components/${componentDef.file}.js`).then(
			({ default: componentClass }) => {
				const instance = this.createInstance(
					element,
					componentDef.name,
					componentClass
				)

				if (instance) {
					this.instances.push(instance)
				}
				return { instance: instance, element: element }
				//   return { name: componentDef.name, instance: mod.default() };
			}
		)

		return promise
	}

	getComponentByElement(element) {
		if (!element) {
			return
		}

		return element['__component__']
	}

	queryComponents(selector, context) {}

	// Destroy a component by element
	destroyElement(element) {
		const instance = this.getComponentByElement(element)
		if (!instance) return

		this.destroyInstance(instance)
	}

	// Destroy a component by instance
	destroyInstance(instance) {
		if (!instance) return

		const element = instance.getElement()
		instance.preUnmount()
		element['__component__'] = null
	}

	removeComponents(context) {
		if (!context) {
			context = document
		}

		// check if the current context has components with the registered selectors
		this.components.forEach((component) => {
			context
				.querySelectorAll(`${component.selector}`)
				.forEach((element) => {
					const instance = this.getComponentByElement(element)

					if (instance) {
						this.destroyInstance(instance)
					}

					if (this.options.debug) {
						console.info(
							`[SMPL-CMPNTS]: Component destroyed "${component.name}" selector(${component.selector})`
						)
					}
				})
		})
	}

	loadComponents(context, callback) {
		if (!this.components.length) {
			console.log('No components defined')
			return
		}
		if (!context) {
			context = document
		}

		let promises = []

		// check if the current context has components with the registered selectors
		this.components.forEach((component) => {
			context
				.querySelectorAll(`${component.selector}`)
				.forEach((element) => {
					// check if the element already has a component instance
					const instance = this.getComponentByElement(element)

					// if the component is already loaded, skip it
					if (instance) {
						if (this.options.debug) {
							console.info(
								`[SMPL-CMPNTS]: Skipped loading "${component.name}" selector(${component.selector}) already loaded`
							)
						}
						return
					}

					let loadPromise = this.loadComponent(element, component)
					promises.push(loadPromise)

					if (this.options.debug) {
						console.info(
							`[SMPL-CMPNTS]: Start loading "${component.name}" selector(${component.selector}) `
						)
					}
				})
			//   console.log(component);
			//   promises.push(import(`${this.path}/${component.file}.js`));
			//   let test = import(`${this.path}/${component.file}.js`).then((mod) => {
			//     console.log(component);
			//     console.log(mod.default());
			//   });
			//   let componentObj = import(`${this.path}/${component.file}.js`);
			//   console.log(componentObj);
		})

		if (promises.length > 0) {
			Promise.all(promises).then((loadedModules) => {
				// mount the loaded components
				loadedModules.forEach(({ instance }) => {
					if (this.options.debug) {
						console.info(`[SMPL-CMPNTS]: Mounted "${instance._name}"  `)
					}

					instance.preMount()
				})

				// Call the callback function once all components are mounted
				if (typeof callback === 'function') {
					callback()
				}
			})
		} else {
			// If there are no components to load, execute the callback immediately
			if (typeof callback === 'function') {
				callback()
			}
		}

		// walk through all components and import the file and call the default function
		//  this.components.forEach((component) => {

		// Promise.all(modulesToLoad).then((loadedModules) => {
		//     console.log(loadedModules)
		//     loadedModules.forEach((mod) => {
		//       mod.default()
		//     });

		//   }).catch(error => {
		//     // Afhandelen van eventuele fouten bij het laden van de modules
		//   });
	}

	registerComponents(components) {
		components.forEach((component) => {
			let componentObj = {
				file: component.file,
				selector: component.selector,
			}

			if (this.options.debug) {
				console.info(
					`[SMPL-CMPNTS]: Registered "${component.name}" (${component.selector})`
				)
			}

			this.components.push(component)
		})
	}

	//   findElements() {
	//     // create a list of selectors

	//     // create a list of selectors from an array of objects which has a selector property
	//     const selectors = this.componentsDef.map((component) => {
	//       return component.selector;
	//     });

	//     console.log(selectors);
	//   }
	init() {
		this.registerComponents(this.componentsDef)
		this.loadComponents()
	}

	//
	getInstances() {
		return this.instances
	}
}

// const ComponentsManager = new SmplComponents();
const smplComponentsInstance = new SmplComponents()
export { smplComponentsInstance as ComponentsManager }

// ------------------------------------------------------------------------- //

export class Component {
	constructor(element, options) {
		this.element = element

		this.element = element
		this.element['__component__'] = this

		this.options = options || {}

		this.eventBus = new EventBus(this.options)

		// this.element['__gia_component__'] = this;
		// this._ref = {};
		// this._options = options || {};
		// this._state = {};
	}

	getElement() {
		return this.element
	}

	prepare() {}

	mount() {
		console.warn(`Mount method not implemented: ${this._name}`)
	}

	unmount() {
		console.warn(`Unmount method not implemented: ${this._name}`)
	}

	//
	preMount() {
		this.mount()
	}
	preUnmount() {
		this.unmount()
	}
}
